import { Component, OnInit, ViewChild } from '@angular/core';
import { DetailComponent } from './../detail/detail.component';

@Component({
  selector: 'app-enabler',
  templateUrl: './enabler.component.html',
  styleUrls: ['./enabler.component.scss']
})
export class EnablerComponent implements OnInit {

  @ViewChild(DetailComponent) detail : DetailComponent;

  title = 'Enablers';
  cardType = 'enabler';
  buttonType = 'enabler';

  apiEnablers  = [
      {
          title: 'API Tester and Registrar',
          caption: 'Test and register your APIs here',
          image: './assets/img/test_api.jpg',
          buttonName: 'Test/Register',
          apiRoute: '/devex'
      }
      // {
      //     title: 'API Registrar',
      //     caption: 'Register your APIs here',
      //     image: './assets/img/register_api_1.jpg',
      //     buttonName: 'Register',
      //     apiRoute: '/devex'
      // },
      // {
      //     title: 'API Documentor',
      //     caption: 'Document your APIs',
      //     image: './assets/img/third_party_api.jpg',
      //     buttonName: 'View Documentation',
      //     apiRoute: '/docs'
      // },
      // {
      //     title: 'API Marketplace',
      //     caption: 'Collection of all your APIs',
      //     image: './assets/img/market_place_1.png',
      //     buttonName: 'View Marketplace',
      //     apiRoute: '/marketplace'
      // }
  ];

  constructor() { }
  ngOnInit(): void {
  }

}
